export default __webpack_public_path__ + "static/media/Laminate.b3ce7f53.png";